import { ImageName } from "@mcleod/images";
import { DataSource } from "../..";
import { HorizontalSpacer } from "../../page/HorizontalSpacer";
import { Button } from "../button/Button";
import { Label } from "../label/Label";
import { Panel } from "../panel/Panel";
import { Layout } from "./Layout";

export class WidgetTitleBar extends Panel {
    private _layout: Layout;
    private _titleLabel: Label;
    private _refreshButton: Button;

    constructor(layout: Layout) {
        super({ fillRow: true, backgroundColor: "primary.darker", height: 42 });
        this._layout = layout;
        this.addTitleLabel();
        this.addRefreshButton();
        this.refresh();
    }

    public get refreshButton(): Button {
        return this._refreshButton;
    }

    public get layout(): Layout {
        return this._layout;
    }

    private addRefreshButton() {
        if (this.layout.displayRefresh === true) {
            this._refreshButton = new Button({
                busyWhenDataSourceBusy: true, dataSource: this.layout.mainDataSource,
                imageName: ImageName.refresh, onClick: () => this.refresh(), borderWidth: 0, color: "primary.reverse", padding: 4, rowBreak: false
            });
            this._refreshButton._interactionEnabled = this.__designer == null;
            this.add(new HorizontalSpacer());
            this.add(this._refreshButton);
        }
    }

    private addTitleLabel() {
        this._titleLabel = new Label({ fontSize: "xlarge", color: "primary.reverse", rowBreak: false, text: this.layout.title });
        this._titleLabel._interactionEnabled = this.__designer == null;
        this.add(this._titleLabel);
    }

    public setTitle(value: string) {
        this._titleLabel.text = value;
    }

    refresh(): void {
        if (this._layout?.dataSourceIDs != null) {
            for (const dataSourceId of this._layout.dataSourceIDs) {
                const filter = (this._layout[dataSourceId] as DataSource).getSearchFilter();
                (this._layout[dataSourceId] as DataSource).search(filter?.data);
            }
        }
    }
}
